// extracted by mini-css-extract-plugin
module.exports = {"tabs":"RoundManager_tabs__2b3SR","headerCol":"RoundManager_headerCol__33i5E"};